import { render } from "./AdminJobSettings.vue?vue&type=template&id=454cadb7&scoped=true"
import script from "./AdminJobSettings.vue?vue&type=script&lang=js"
export * from "./AdminJobSettings.vue?vue&type=script&lang=js"

import "./AdminJobSettings.vue?vue&type=style&index=0&id=454cadb7&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454cadb7"]])

export default __exports__